import { Badge, Button, ScrollArea } from '@ibsys/kit';
import { XIcon } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SCROLL_AREA_VIEWPORT_BLOCK } from '@/shared/lib';
import { formatNumericFilterItem, type NumericFilterItem } from './numericFilterValue';

/** Пропсы перечня набранных элементов отбора */
type Props = {
  items: NumericFilterItem[];
  /** Убирает один элемент перечня; элемент назван так же, как показан */
  onRemove: (label: string) => void;
  /** Набранное не правится: отбор задан не значением */
  disabled?: boolean;
};

/** Набранные элементы отбора: каждый показан отдельно и снимается по одному */
export const NumericFilterValuesList: FC<Props> = ({ items, onRemove, disabled }) => {
  const { t } = useTranslation('common');

  if (!items.length) return null;

  return (
    // Число набранных элементов не ограничено, поэтому перечень прокручивается, а не растёт окном
    <ScrollArea orientation="vertical" className={SCROLL_AREA_VIEWPORT_BLOCK} viewPortProps={{ className: 'max-h-40' }}>
      <div className="flex flex-wrap gap-1">
        {items.map((item) => {
          const label = formatNumericFilterItem(item);
          return (
            <Badge key={label} variant="secondary" outline className="gap-1 pr-1">
              {label}
              <Button
                variant="ghost"
                size="icon"
                // Важность обязательна: без неё размер кнопки в бейдже держится на порядке импортов стилей
                className="size-4!"
                aria-label={t('numericFilter.removeValue', { value: label })}
                icon={<XIcon className="size-3" />}
                disabled={disabled}
                onClick={() => onRemove(label)}
              />
            </Badge>
          );
        })}
      </div>
    </ScrollArea>
  );
};
